import React, { useEffect} from 'react'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import EmptyAccountsList from 'views/Administration/Account/AccountList/EmptyAccountsList'
import List from 'views/Administration/Account/AccountList/List'
import { notificationToast } from 'components'

function AccountListContainer({ navigate }) {
  const [
    { data: listAccountsResponse, loading: listAccountsLoading, error: listAccountsError },
    listAccount
  ] = useAxios(
    {
      url: 'administration/accounts',
      method: 'GET',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const [
    { data: enableAccountResponse, loading: enableAccountLoading, error: enableAccountError },
    enableAccount
  ] = useAxios(
    {
      url: 'account/change-account-status',
      method: 'POST',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const handleEnableAccount = id => {
    enableAccount({ data: { account_id: id } })
  }

  const openNotification = (message, errors) => {
    if (!errors) {
      notificationToast({
        message: 'Success',
        description: 'Account status has changed',
        icontype: 'check'
      })
    } else {
      notificationToast({
        message: 'Error',
        description: `${message} ${errors.join()}`,
        icontype: 'alert'
      })
    }
  }

  useEffect(() => {
    listAccount()
    let interval = setInterval(() => {
      listAccount()
    }, 120000)
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [])

  useEffect(() => {
    if (listAccountsResponse && listAccountsResponse.Errors && listAccountsResponse.Errors.length) {
      openNotification('Cannot preview administration.', listAccountsResponse.Errors)
    }
  }, [listAccountsResponse])

  useEffect(() => {
    if (enableAccountResponse && enableAccountResponse.Errors && enableAccountResponse.Errors.length) {
      openNotification('Account status could not be changed.', enableAccountResponse.Errors)
    }
    if (enableAccountResponse) {
      listAccount()
      openNotification('Account status changed.')
    }
  }, [enableAccountResponse])

  if (
    !listAccountsResponse ||
    (listAccountsResponse && listAccountsResponse.Errors && listAccountsResponse.Errors.length)
  )
    return <EmptyAccountsList />
  return (
    
    <List
      data={listAccountsResponse}
      loading={listAccountsLoading}
      error={listAccountsError}
      handleEnableAccount={handleEnableAccount}
      listAccount={listAccount}
    />
  )
}

export default AccountListContainer
